import React, { useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../Pages/style.css';
import Footer from '../Pages/Footer';

import ProductHeaderImage from '../Images/productpage.jpg';
import ECGImage from '../Images/ecg18.jpeg';
import MultiParaImage from '../Images/multiparamonitor.jpeg';
import Defibrillator from '../Images/defibrillator.jpeg';
import SyringeInfusionPump from '../Images/syringeinjection.jpeg';
import VolumericInfusionPump from '../Images/volumeinjection.jpeg';
import PulseOximeter from '../Images/pulsetabletop.jpeg';
import Cardiotocography from '../Images/ctg.jpeg';
import AutoHematologyAnalyzer from '../Images/AHA.jpeg';
import MrpDetail from '../Images/mrp6000.jpeg';
import PortableUltrasoundMachine from '../Images/USG.jpg';
import OTT from '../Images/ott.jpg';

const products = [
  {
    name: 'Color Dopplers & Ultrasound',
    img: PortableUltrasoundMachine,
    path: '/products/portableultrasoundmachine',
    category: 'Imaging',
    description: 'High resolution imaging for accurate diagnostics.',
  },
  {
    name: 'ECG Machine',
    img: ECGImage,
    path: '/products/ecg',
    category: 'Cardiology',
    description: 'Advanced ECG analysis with clear results.',
  },
  {
    name: 'Multiparameter Monitor',
    img: MultiParaImage,
    path: '/products/multiparamonitor',
    category: 'Paitents Monitoring',
    description: 'Real-time monitoring with advanced patient parameters.',
  },
  {
    name: 'Cardiotocography',
    img: Cardiotocography,
    path: '/products/cardiotocography',
    category: 'Obstetrics',
    description: 'Fetal monitoring for better maternal care.',
  },
  {
    name: 'Defibrillator',
    img: Defibrillator,
    path: '/products/defibrillator',
    category: 'Emergency Care',
    description: 'Advanced life support defibrillator.',
  },
  {
    name: 'Auto Hematology Analyzer',
    img: AutoHematologyAnalyzer,
    path: '/products/autohematologyanalyzer',
    category: 'Laboratory',
    description: 'Accurate & quick blood analysis.',
  },
  {
    name: 'General OT Table',
    img: OTT,
    path: '/products/ott',
    category: 'Surgical',
    description: 'Ergonomic design for surgical procedure.',
  },
  {
    name: 'Infusion Pump',
    img: SyringeInfusionPump,
    path: '/products/syringeInfusionpump',
    category: 'Infusion',
    description: 'Advanced controlled fluid infusion techology.',
  },
  {
    name: 'Pulse Oximeter',
    img: PulseOximeter,
    path: '/products/pulseoximeter',
    category: 'Monitoring',
    description: 'Ergonomic design for surgical procedure.',
  },
];

const categoryColors = {
  Imaging: '#e8f0fe',
  Cardiology: '#fce8e8',
  Monitoring: '#e8f5e9',
  Obstetrics: '#fff3e0',
  Emergency: '#fdecea',
  Diagnostics: '#ede7f6',
  Surgical: '#e0f2f1',
  Infusion: '#e3f2fd',
};

const categoryTextColors = {
  Imaging: '#1a56db',
  Cardiology: '#c0392b',
  Monitoring: '#2e7d32',
  Obstetrics: '#e65100',
  Emergency: '#b71c1c',
  Diagnostics: '#6a1b9a',
  Surgical: '#00695c',
  Infusion: '#0277bd',
};

const Product = () => {
  const contentRef = useRef(null);
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <>
      <Helmet>
        <title>Medical Devices & Diagnostic Equipment | Mindron Meditech</title>
        <meta
          name="description"
          content="Explore medical devices and diagnostic equipment by Mindron Meditech including ECG machines, multipara monitors, ultrasound machines, defibrillators, CTG monitors, hematology analyzers, OT tables, infusion pumps, and pulse oximeters."
        />
        <link
          rel="canonical"
          href="https://www.mindronmeditech.com/products"
        />
      </Helmet>

      <div style={{ overflowX: 'hidden', backgroundColor: '#eef7ff' }}>
        {/* HERO BANNER */}
        <div
          className="header-container"
          style={{
            position: 'relative',
            width: '100%',
            height: '80vh',
            overflow: 'hidden',
            minHeight: '300px',
          }}
        >
          <img
            src={ProductHeaderImage}
            alt="Product Header"
            style={{
              width: '100%',
              height: '110%',
              objectFit: 'cover',
              display: 'block',
            }}
          />

          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(to top, rgba(0,20,60,0.4) 0%, transparent 60%)',
            }}
          />
        </div>

        {/* PRODUCTS HEADING */}
        <div ref={contentRef} style={{ padding: '40px 5% 20px' }}>
          <div
            style={{
              width: '50px',
              height: '5px',
              backgroundColor: '#cc0000',
              marginBottom: '12px',
            }}
          />

          <h2
            style={{
              fontSize: '28px',
              fontWeight: '800',
              color: '#111',
              margin: 0,
              letterSpacing: '1px',
            }}
          >
            PRODUCTS
          </h2>
        </div>

        {/* PRODUCT GRID */}
        <div style={{ padding: '10px 5% 40px' }}>
          <div className="product-grid-new">
            {products.map((p, index) => (
              <div
                key={index}
                className="product-card-new"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  background: '#fff',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow:
                    hoveredIndex === index
                      ? '0 8px 24px rgba(0,0,0,0.14)'
                      : '0 2px 10px rgba(0,0,0,0.07)',
                  transform:
                    hoveredIndex === index
                      ? 'translateY(-4px)'
                      : 'translateY(0)',
                  transition: 'all 0.25s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                }}
                onClick={() => navigate(p.path)}
              >
                {/* Image area */}
                <div
                  style={{
                    background: 'white',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '200px',
                    position: 'relative',
                  }}
                >
                  {/* Category pill top-right */}
                  <span
                    style={{
                      position: 'absolute',
                      top: '12px',
                      right: '12px',
                      backgroundColor: categoryColors[p.category] || '#f0f0f0',
                      color: categoryTextColors[p.category] || '#333',
                      fontSize: '11px',
                      fontWeight: '600',
                      padding: '3px 10px',
                      borderRadius: '20px',
                      zIndex: 2,
                    }}
                  >
                    {p.category}
                  </span>

                  <img
                    src={p.img}
                    alt={p.name}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      objectFit: 'contain',
                    }}
                  />

                  {/* View Details — centered bottom, shows on hover */}
                  {hoveredIndex === index && (
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#001F54',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: '600',
                        padding: '6px 16px',
                        borderRadius: '20px',
                        whiteSpace: 'nowrap',
                        zIndex: 2,
                        cursor: 'pointer',
                      }}
                    >
                      View Details →
                    </div>
                  )}
                </div>

                {/* Text area */}
                <div
                  style={{
                    padding: '16px 16px 20px',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <h3
                    style={{
                      fontSize: '15px',
                      fontWeight: '700',
                      color: '#111',
                      margin: '0 0 8px',
                    }}
                  >
                    {p.name}
                  </h3>

                  <p
                    style={{
                      fontSize: '13px',
                      color: '#666',
                      lineHeight: '1.6',
                      margin: 0,
                      flex: 1,
                    }}
                  >
                    {p.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FOOTER */}
        <Footer />

        {/* CSS */}
        <style>{`
          .product-grid-new {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }

          @media (max-width: 900px) {
            .product-grid-new {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 540px) {
            .product-grid-new {
              grid-template-columns: repeat(2, 1fr);
              gap: 12px;
            }
          }

          @media (max-width: 768px) {
            .header-container {
              height: 30vh !important;
            }
          }

          *::-webkit-scrollbar {
            display: none;
          }

          * {
            scrollbar-width: none;
          }

          body {
            overflow-x: hidden;
          }
        `}</style>
      </div>
    </>
  );
};

export default Product;